import { Component, OnInit, TemplateRef } from '@angular/core';
import { UserService } from './user.service';
import { User } from './user';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap/modal';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DepartmentService } from '../department/department.service';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { NgxSpinnerService } from "ngx-spinner";												
import { LocalService } from '../../local.service';
import { environment } from '../../../environments/environment';
import {encryptdecrypt} from '../../encryptdecrypt';
@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.css']
})
export class UserComponent implements OnInit {
  sendMenuId: number = 1;
  sendPageName: string = 'Add User';
  Users: User[]=[];
  UserList: any = [];
  UserListactive: any = [];
  
  p: number = 1; public searchText: string;
  itemsPerPage: number = 10;

  showall: boolean = true;
  showallstatus: boolean = false;
  _actionRights: any; _menuId: any; readOnly: boolean; add: boolean; edit: boolean; delete: boolean; submitShow: boolean;
  //useridnew: string = localStorage.getItem("userid");
  useridnew: string = this.localService.getJsonValue("userid");
  autologAdminId:string=environment.autologAdmin;
  AdminTeamId:number=environment.AdminTeamId;
  constructor(
    private userservice: UserService,    
    private router: Router,   
	private SpinnerService: NgxSpinnerService,  											
    private dialogService: DialogService,
    private toastr: ToastrService, private localService: LocalService) {
   
    if (this._menuId == undefined) {
      this._menuId = localStorage.getItem('UserManagement_menuid');
      this.sendMenuId = this._menuId;
    }
    if (this._actionRights == undefined)  
      this._actionRights = localStorage.getItem('UserManagement_action');

  }

  
  ngOnInit() {
	this.SpinnerService.show();						   
    this.getActionRightsList();
    this.getAll();
    console.log(this.useridnew);
  }

  getAll() {
	this.SpinnerService.show();							   
    this.UserList = [];
    this.UserListactive = [];
        let a= new encryptdecrypt(); 
    this.userservice.Get().subscribe(res => {
 res.forEach((data: any) => {
        data.firstname = a.decryptUsingAES256(data.firstname);
        data.lastname = a.decryptUsingAES256(data.lastname);
        data.emailid = a.decryptUsingAES256(data.emailid);
      });
      this.Users = res;
      var alldata = res;
      var _allData=[];var autologUserList=[];
      console.log(alldata); 
      
      var loggeduser=alldata.filter(ele=>ele.userid.toString()==this.useridnew.toString());
      autologUserList=alldata.filter(m=>m.isautologuseronly>0);
      var _autologuser=0;var _autologadmin='';var _autologinputstr=''; var productLineList=[];var loggeduserteam=0;
      if(loggeduser!=undefined && loggeduser.length>0){
        _autologuser =+loggeduser[0]['isautologuseronly'];
        _autologadmin=loggeduser[0]['isautologadmin'].toString();
        _autologinputstr=_autologuser>0?loggeduser[0]['autologinputstr'].toString():'';
        loggeduserteam=+loggeduser[0]['teamid']
      }     
      if(_autologuser>=1 && _autologadmin=='0'){//product admin
        productLineList=JSON.parse(_autologinputstr);  
        var prdExists=0;   
        var isPrdLineAdminLst= productLineList.filter(y=>y.role=='Admin');
        if(isPrdLineAdminLst!=undefined && isPrdLineAdminLst.length>0){
        autologUserList.forEach(e=>{      
          isPrdLineAdminLst.forEach(f=>{       
         var prdList=[];prdExists=0;
         prdList=JSON.parse(e.autologinputstr);
          if(prdList.filter(m=>m.productlineid==f.productlineid)!=undefined && 
          prdList.filter(m=>m.productlineid==f.productlineid).length>0)
          {
            prdExists++;
          }       
      });
   
      if(prdExists>0){
      _allData.push({userid: e.userid, firstname: e.firstname, lastname: e.lastname, emailid: e.emailid,
        team: e.team, active: e.active, isautologadmin:e.isautologadmin,autologinputstr:e.autologinputstr,
        isautologuseronly:e.isautologuseronly          
      });
    }
       });
      }
      else
      {
        _allData=[];
      }
        }
       if(_autologuser>=1 && _autologadmin=='1'){//autologin admin
          _allData=autologUserList;
        }
        if(_autologuser==0){//acrn admin          
          _allData=alldata.filter(m=>m.isautologuseronly==0);
        }
        
        if(this.AdminTeamId==loggeduserteam && _autologuser>=1){
          _allData=[];
          _allData=alldata;
        }
if(_allData.length>0){1
        _allData.forEach(data => {    
           this.UserList.push({
          userid: data.userid, firstname: data.firstname, lastname: data.lastname, emailid: data.emailid,
          team: data.team, active: data.active,isautologuser:data.isautologuseronly>0 ? "True": "False",
          isautologadmin:data.isautologadmin,autologinputstr:data.autologinputstr,
          isautologuseronly:data.isautologuseronly          
        })
        if (this.showallstatus == true) {
          this.UserList.forEach(data => {
            if (data.active == 1) {
              this.UserListactive.push(data);
            }
          });
          this.UserList = [];
          this.UserList = this.UserListactive;
        }
        //}
      });
    }
		this.SpinnerService.hide();						 
    }, error => { 
	this.SpinnerService.hide();
	this.toastr.error('Error while getting users data') });   

  }

  getActionRightsList() {
this.SpinnerService.show();
    var btnToEnable = JSON.parse(this._actionRights);
    if (btnToEnable.length > 0) {
      btnToEnable.forEach(d => {
        if (d != undefined) {
          if (d == 1)
            this.readOnly = true;
          else if (d == 2) {
            this.readOnly = true;
            this.add = true;
            this.submitShow = true;
          }
          else if (d == 3) {
            this.readOnly = true;
            this.edit = true;
            // this.submitShow = true;
          }
          else if (d == 4) {
            this.readOnly = true;
            this.delete = true;
          }
        }
      });
    }
	 this.SpinnerService.hide();						   
  }



  getactiveinactive(showallp) {
	this.SpinnerService.show();						   
    this.UserListactive = [];
    this.showall = showallp;
    this.showallstatus = showallp;
    if (this.showall == true) {
      this.showall = false;
      this.UserList.forEach(data => {
        if (data.active == 1) {
          this.UserListactive.push(data);
        }
      });
      this.UserList = [];
      this.UserList = this.UserListactive;
    }
    else {
      this.showall = true;
      this.UserList = [];
      this.getAll();
    }
	this.SpinnerService.hide();						   
  }
  key: string = 'firstname'; //set default
  reverse: boolean = false;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }

  calluseradd(userid: number) {
 this.SpinnerService.show();
    this.router.navigate(['/home/useradd'], { queryParams: { userid: userid } });
    //  .then(() => {
    //  window.location.reload(true);
    //});
  }


  OpenConfirmTemplate(user: User) {

   
    var confmsg;
 
    if (user.active == 0) {
      confmsg = "activate";
    }
    else
      confmsg = "deactivate";
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + confmsg + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
	//	this.SpinnerService.show();						   
        if (isConfirmed) {        
          this.Delete(user);
        }

      });
  }

 
  Delete(user: User) {
    var msg;
    this.SpinnerService.show();
    if (user.active == 0) {
      user.active = 1
      msg = "User activated successfully"
    }
    else {
      user.active = 0;
      
      if(user.isautologuseronly >0){
      user.autologapitoken=this.localService.getJsonValue('apitoken');
      user.modifiedby = +this.localService.getJsonValue('userid');
      var input={};
      let loggedusremail= this.localService.getJsonValue('emailid');
      input['loginId']=user.emailid;
      input['changedBy']=loggedusremail;//this.autologAdminId;
      user.apiautologinputstr=JSON.stringify(input);
     
      }
      msg = "User deactivated successfully"
    }
    this.userservice.Delete(user).subscribe(res => { this.toastr.success(msg); 
	 this.SpinnerService.hide();
	 }, error =>
{ 
this.SpinnerService.hide();
this.toastr.error("Operation is not successfull"); })

  }
  
  
}
